/* global sessionStorage */
import * as React from 'react';
import classnames from 'classnames';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import NavigationMenu from '../components/NavigationMenu/NavigationMenu';
import { StateContext } from '../context/context';
import DownArrow from '../components/DownArrow/DownArrow';
import { login as loginStyle, pageMenuOpen, page, hidden } from './Layout.module.scss';
import './Layout.scss';
import PreloadData from './PreloadData';

const Layout = ({
    children,
    className,
    isNonCompliantPage = false,
    deferDisclaimer = false,
    showNavigation = true,
    hideLogoText = true,
    footerVisible = true,
    getInTouchVisible = true,
    login = false,
    hasDownArrow = false,
    admin = false,
    portal = false
}) => {
    const [navigationMenuOpened, setNavigationMenuOpened] = React.useState(false);
    const {
        disclaimer: { showDisclaimer },
        auth: { authenticated }
    } = React.useContext(StateContext);

    const pageClassnames = classnames(className, {
        [pageMenuOpen]: navigationMenuOpened,
        [loginStyle]: login
    });

    React.useEffect(() => {
        if (typeof document === 'undefined') {
            return undefined;
        }
        document.body.classList.toggle('menu-open', navigationMenuOpened);
        return () => {
            document.body.classList.remove('menu-open');
        };
    }, [navigationMenuOpened]);

    function closeMenu() {
        setNavigationMenuOpened(false);
    }

    return (
        <>
            {!isNonCompliantPage && <Disclaimer deferAutoShow={deferDisclaimer} />}
            <div className={classnames(page, { [hidden]: showDisclaimer })}>
                <Header
                    admin={admin}
                    portal={portal}
                    showNavigation={showNavigation}
                    onMenuToggled={setNavigationMenuOpened}
                    menuOpen={navigationMenuOpened}
                    hideLogoText={hideLogoText}
                />
                <NavigationMenu authenticated={authenticated} open={navigationMenuOpened} closeMenu={closeMenu} />
                <div className={pageClassnames}>
                    {children}
                    {footerVisible ? <Footer getInTouchVisible={getInTouchVisible} /> : null}
                </div>
                {hasDownArrow && <DownArrow />}
            </div>
            {!admin && <PreloadData />}
        </>
    );
};

export default Layout;
